// src/components/ReactDataGridCustom.js
import React, { useEffect } from "react";
import ReactDataGrid from "@inovua/reactdatagrid-community";
import { i18nTable, THEME } from "../../constants";
import useTheme from "../../hooks/useTheme";

const ReactDataGridCustom = ({ filterValue, onFilterValueChange, ...otherProps }) => {
    const { theme } = useTheme();

    return (
        <ReactDataGrid
            style={{ minHeight: "65vh" }}
            i18n={i18nTable}
            theme={theme === THEME.DARK ? "default-dark" : "default-light"}
            emptyText={"Geen data beschikbaar verwijder of reset je filters"}
            filterValue={filterValue} // Filterwaarde doorgeven
            onFilterValueChange={onFilterValueChange} // Filter update-functie doorgeven
            {...otherProps}
        />
    );
};

export default ReactDataGridCustom;
